import { render, staticRenderFns } from "./EmailDraftDashlet.vue?vue&type=template&id=63ac1932"
import script from "./EmailDraftDashlet.vue?vue&type=script&lang=js"
export * from "./EmailDraftDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports